export const jobSalaryPeriodsEn = {
  jobSalaryPeriods: {
    'hour': 'Hour',
    'day': 'Day',
    'week': 'Week',
    'month': 'Month',
    'year': 'Year'
  }
};
